import { Grid } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import ToggleGroup from 'src/components/toggle-group';
import { togglePlannerGridView } from '../../store/planner-slice';

export default function PlannerDynamicToggle() {
  const appDispatch = useAppDispatch();
  const { isFetchingToggleData, toggles, toggledView } = useAppSelector(
    (state) => state.plannerV2
  );

  const formattedToggleDetails: { label: string; value: string }[] =
    toggles.map((data) => ({
      label: data.alias,
      value: data.key
    }));

  return (
    <>
      {isFetchingToggleData && (
        <>
          <Grid item xs='auto'>
            <Skeleton variant='text' sx={{ fontSize: '1rem' }} width={40} />
          </Grid>
          <Grid item>
            <Skeleton variant='text' sx={{ fontSize: '1rem' }} width={40} />
          </Grid>
        </>
      )}
      {!isFetchingToggleData && (
        <Grid item xs='auto'>
          <ToggleGroup
            onToggle={(value) => {
              appDispatch(togglePlannerGridView(value as string));
            }}
            toggleValue={toggledView}
            toggles={formattedToggleDetails}
          />
        </Grid>
      )}
    </>
  );
}
